module.exports = __webpack_public_path__ + "static/media/clinical_website_icon.2bce8e00.svg";